import * as React from "react"
import { Typography, Box } from "@mui/material"

import WrapperBlock from "./WrapperBlock"

const TEXTS = {
    'error': { text: 'Error', color: 'error' },
    'na': { text: 'N/A', color: 'disabled.main' },
    'not-found': { text: 'Not Found', color: 'info' }
}

export default function ErrorInfoCell({status=''}) {

    const { text='-', color='' } = TEXTS[status] || {}

    return <WrapperBlock color={color}>
        <Box display="flex" alignItems="center"><Typography component="span">{text}</Typography></Box>
    </WrapperBlock>
}